import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AlertComponent from "../../components/AlertComponent";
import { Context } from "../../Reducers/Store";
import { apiUrl, getPayload } from "../../services/apiConfig";
import { errorMessage } from "../../utils/formatters";

export default function Login() {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (state.isLogged) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate, state.isLogged]);

  const handleLogin = (event) => {
    event.preventDefault();
    axios
      .post(apiUrl("/auth/login"), { login, senha })
      .then((response) => {
        dispatch({ type: "SET_LOGGED", payload: getPayload(response) });
        navigate(location.state?.from?.pathname || "/dashboard", { replace: true });
      })
      .catch((error) => {
        AlertComponent("Erro", errorMessage(error, "Usuário ou senha inválidos."), { icon: "error" });
      });
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center px-4 py-10"
      style={{ background: "linear-gradient(160deg, #1e1b4b 0%, #3b0764 100%)" }}
    >
      <div className="w-full max-w-md">
        <div className="mb-8 flex items-center justify-center gap-3">
          <div
            className="flex h-11 w-11 items-center justify-center rounded-2xl text-white shadow-lg shadow-purple-950/40"
            style={{ background: "linear-gradient(135deg,#8b5cf6,#6d28d9)" }}
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 10V3L4 14h7v7l9-11h-7Z" />
            </svg>
          </div>
          <span className="text-lg font-bold tracking-wide text-white">SMS Agendador</span>
        </div>

        <div className="rounded-3xl bg-white/95 p-7 shadow-2xl shadow-purple-950/40 ring-1 ring-white/20 backdrop-blur-xl sm:p-9">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-slate-900">Acessar sistema</h1>
          <p className="mt-2 text-sm text-slate-500">Entre para visualizar e executar os jobs liberados para seu usuário.</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="mb-2 block text-xs font-semibold uppercase tracking-wider text-slate-600">Usuário</label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-slate-400">
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.5 20.25a8.25 8.25 0 0 1 15 0" />
                </svg>
              </span>
              <input
                type="text"
                value={login}
                onChange={(event) => setLogin(event.target.value)}
                className="w-full rounded-xl border border-slate-200 bg-slate-50/50 py-2.5 pl-10 pr-3 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-transparent focus:bg-white focus:ring-2 focus:ring-violet-500"
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div>
            <label className="mb-2 block text-xs font-semibold uppercase tracking-wider text-slate-600">Senha</label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-slate-400">
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16.5 10.5V7.5a4.5 4.5 0 0 0-9 0v3m-.75 0h10.5A1.75 1.75 0 0 1 19 12.25v6A1.75 1.75 0 0 1 17.25 20H6.75A1.75 1.75 0 0 1 5 18.25v-6a1.75 1.75 0 0 1 1.75-1.75Z" />
                </svg>
              </span>
              <input
                type={showPassword ? "text" : "password"}
                value={senha}
                onChange={(event) => setSenha(event.target.value)}
                className="w-full rounded-xl border border-slate-200 bg-slate-50/50 py-2.5 pl-10 pr-10 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-transparent focus:bg-white focus:ring-2 focus:ring-violet-500"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword((value) => !value)}
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400 transition hover:text-violet-600"
                tabIndex={-1}
                title={showPassword ? "Ocultar senha" : "Mostrar senha"}
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {showPassword ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3l18 18M10.58 10.58A2 2 0 0 0 12 14a2 2 0 0 0 1.42-.58M9.88 5.09A10.4 10.4 0 0 1 12 4.88c4.5 0 8.27 2.94 9.54 7a10.5 10.5 0 0 1-3.07 4.63M6.61 6.61a10.43 10.43 0 0 0-4.15 5.27A10.5 10.5 0 0 0 12 19.13c1.03 0 2.02-.15 2.95-.43" />
                  ) : (
                    <>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.46 12C3.73 7.94 7.52 5 12 5s8.27 2.94 9.54 7c-1.27 4.06-5.06 7-9.54 7S3.73 16.06 2.46 12Z" />
                    </>
                  )}
                </svg>
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="w-full rounded-xl px-4 py-3 text-sm font-semibold tracking-wide text-white shadow-lg shadow-purple-900/30 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-purple-900/50 active:translate-y-0"
            style={{ background: "linear-gradient(135deg,#7c3aed,#6d28d9)" }}
          >
            Entrar
          </button>
        </form>

        <div className="mt-6 flex justify-end">
          <Link to="/primeiro-admin" className="text-sm font-medium text-violet-600 transition hover:text-violet-800 hover:underline">
            Criar primeiro administrador
          </Link>
        </div>
      </div>
      </div>
    </div>
  );
}
